export default {
  namespaced: true,
  pacom: {
    pacom: "pacom",
    masterAccounts: "cuentas maestras",
    masterAccount: "cuenta maestra",
    first_name: "nombre",
    last_name: "apellidos",
    link: "enlace",
    username: "nombre de usuario",
    token: "token",
    password: "contraseña",
    token_expired: "expiración de token",
    email: "email",
    sites: "sitios",
    site: "sitio",
    name: "nombre",
    description: "descripción",
    address: "dirección",
    latitude: "latitud",
    longitude: "longitud",
    timeZone: "zona horaria",
    profile: "perfil",
    calendar: "calendario",
    serialNumber: "numero de serie",
    actions: "acciones",
    schemaTypes: "tipos de esquema",
    schema_type: "tipo de esquema",
    display_name: "nombre para mostrar",
    id: "id",
    devices: "dispositivos",
    gateway_id: "id de gateway",
    schema_actions: "acciones de esquema",
    typeAlarm: "tipo de alarma",
    typeAlarms: "tipos de alarma",
    priority: "prioridad",
    dispatchAlarm: "disparar alarma",
    alarms: "alarmas",
    state: "estado",
    creation_time: "fecha de creación",
    units: "unidades",
    center: "centro",
    sector: "sector",
    device: "dispositivo",
    schemaEvent: "tipo evento",
    time: "hora",
    type: "tipo",
    logs: "logs",
    resources: "recursos",
    id: "id",
    idAlarm: "id alarma",
    color: "color",
    status: "estado"
  }
}
